import { FC } from "react";

interface DropdownArrowSVGProps {
    className?: string;
    stroke?: string;
}

const DropdownArrowSVG: FC<DropdownArrowSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="14"
            height="6"
            viewBox="0 0 14 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M13 0.5L7 5.5L1 0.499999" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default DropdownArrowSVG;
